import { render, staticRenderFns } from "./backstage-menu.vue?vue&type=template&id=cc3bc12e&scoped=true&"
import script from "./backstage-menu.vue?vue&type=script&lang=js&"
export * from "./backstage-menu.vue?vue&type=script&lang=js&"
import style0 from "./backstage-menu.vue?vue&type=style&index=0&id=cc3bc12e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3bc12e",
  null
  
)

export default component.exports